import React from "react";

const STATUS_META = {
  input: { label: "Input", cls: "bg-slate-500/10 text-slate-300 border-slate-500/20" },
  editorial: { label: "Editorial", cls: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20" },
  working: { label: "Reference DB", cls: "bg-blue-500/10 text-blue-400 border-blue-500/20" },
  archive: { label: "Archived", cls: "bg-amber-500/10 text-amber-400 border-amber-500/20" },
  deleted: { label: "Deleted", cls: "bg-red-500/10 text-red-400 border-red-500/20" },
};

const PRIORITY_META = {
  high: "bg-red-500/10 text-red-400 border-red-500/20",
  medium: "bg-amber-500/10 text-amber-400 border-amber-500/20",
  low: "bg-slate-500/10 text-slate-400 border-slate-500/20",
};

export const StatusBadge = ({ status }) => {
  const m = STATUS_META[status] || STATUS_META.input;
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 rounded border ${m.cls}`}>
      {m.label}
    </span>
  );
};

export const Tag = ({ children, kind = "keywords", ...props }) => {
  const map = {
    recommendation: "bg-emerald-500/10 text-emerald-400 border-emerald-500/20",
    priority: PRIORITY_META[String(children).toLowerCase()] || "bg-amber-500/10 text-amber-400 border-amber-500/20",
    keywords: "bg-blue-500/10 text-blue-400 border-blue-500/20",
    type: "bg-purple-500/10 text-purple-400 border-purple-500/20",
    category: "bg-slate-500/10 text-slate-300 border-slate-500/20",
  };
  return (
    <span {...props} className={`inline-flex items-center gap-1 font-mono text-[10px] uppercase tracking-wider px-2 py-0.5 rounded border ${map[kind]}`}>
      {children}
    </span>
  );
};
